module.exports = __webpack_public_path__ + "img/RUN-MIDFOOT-A-DROITE.09c46bd0.svg";